export class BaseMaintenanceDto {
    public __order: string;
    public __id: string;
}